<div class="kerettanterv-page">
  <ion-accordion-group [multiple]="true">
    <ion-accordion value="tanterv">
      <ion-item slot="header" color="light">
        <ion-label>
          <h2>Tanterv szerkesztése</h2>
          <p>
            Tantárgyak hozzáadása/törlése és évfolyamhoz rendelése.
            <ng-container *ngIf="tanevLabel">Aktuális tanév: {{ tanevLabel }}.</ng-container>
          </p>
        </ion-label>
      </ion-item>

      <div slot="content" class="ion-padding">
      <!-- Új hozzárendelés -->
      <ion-list lines="full">
        <ion-item>
          <ion-checkbox
            slot="start"
            [checked]="uj.ujTargy"
            (ionChange)="uj.ujTargy = $event.detail.checked"
          ></ion-checkbox>
          <ion-label>Új tantárgy létrehozása</ion-label>
        </ion-item>

        <ion-item *ngIf="!uj.ujTargy">
          <ion-select
            label="Tantárgy"
            label-placement="stacked"
            interface="popover"
            placeholder="Válassz tantárgyat"
            [(ngModel)]="uj.tantargy"
          >
            <ion-select-option *ngFor="let tt of tantargyLista" [value]="tt.id">
              {{ tt.name }}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ng-container *ngIf="uj.ujTargy">
          <ion-item>
            <ion-input label="Tantárgy neve" label-placement="stacked" [(ngModel)]="uj.nev" placeholder="pl. Matematika"></ion-input>
          </ion-item>
          <ion-item>
            <ion-input label="Rövidítés (opcionális)" label-placement="stacked" [(ngModel)]="uj.rovid" placeholder="pl. Mat."></ion-input>
          </ion-item>
          <ion-item>
            <ion-input label="Szín (opcionális)" label-placement="stacked" [(ngModel)]="uj.szin" placeholder="pl. #3880ff"></ion-input>
          </ion-item>
        </ng-container>

        <ion-item>
          <ion-input label="Évfolyam" label-placement="stacked" type="number" [(ngModel)]="uj.evfolyam" placeholder="pl. 2"></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-input label="Heti óraszám" label-placement="stacked" type="number" min="1" [(ngModel)]="uj.db"></ion-input>
        </ion-item>
      </ion-list>

      <div class="ion-padding-top">
        <ion-button color="success" (click)="ujHozzarendeles()" [disabled]="ujHozzaadFolyamatban">
          <ion-icon slot="start" name="add-outline"></ion-icon>
          Hozzáadás a tantervhez
        </ion-button>
      </div>

      <!-- Meglévő hozzárendelések -->
      <ion-note *ngIf="tantervBetolt">Betöltés…</ion-note>
      <ion-note color="medium" *ngIf="!tantervBetolt && !tanterv.length">
        Még nincs tantervi tantárgy ehhez a tanévhez.
      </ion-note>

      <ion-list *ngIf="tanterv.length" lines="full">
        <ion-item *ngFor="let t of tanterv">
          <ion-label class="ion-text-wrap">
            <h2>{{ t.nev }}</h2>
            <div class="tanterv-chipek">
              <ion-chip *ngFor="let e of t.evfolyamok" color="primary">
                <ion-label>{{ e.evfolyam }}. évf. ({{ e.db }} óra)</ion-label>
                <ion-icon name="close-circle" (click)="torolHozzarendeles(e)"></ion-icon>
              </ion-chip>
            </div>
            <div class="tanterv-gyorsadd">
              <ion-input
                type="number"
                fill="outline"
                placeholder="Évf."
                [(ngModel)]="t._ujEvf">
              </ion-input>
              <ion-input
                type="number"
                fill="outline"
                placeholder="Óra"
                [(ngModel)]="t._ujDb">
              </ion-input>
              <ion-button size="small" fill="outline" (click)="gyorsEvfolyam(t, t._ujEvf || '', t._ujDb || 1); t._ujEvf=''">
                + évfolyam
              </ion-button>
            </div>
          </ion-label>
        </ion-item>
      </ion-list>
      </div>
    </ion-accordion>

    <ion-accordion value="sorrend">
      <ion-item slot="header" color="light">
        <ion-label>
          <h2>Kerettanterv – tantárgysorrend</h2>
          <p>
            Húzd a megfelelő sorrendbe a tantárgyakat. Ez a sorrend érvényesül a
            töprengőn és a későbbi pótlapokon.
          </p>
        </ion-label>
      </ion-item>

      <div slot="content" class="ion-padding">
      <ion-note *ngIf="betoltesFolyamatban">Betöltés…</ion-note>
      <ion-note color="medium" *ngIf="!betoltesFolyamatban && !tantargyak.length">
        Nincs a kerettantervhez rendelt tantárgy erre a tanévre.
      </ion-note>

      <ion-list
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        *ngIf="tantargyak.length"
        lines="full"
      >
        <ion-item *ngFor="let t of tantargyak; let i = index" cdkDrag>
          <ion-icon name="reorder-three-outline" slot="start" cdkDragHandle></ion-icon>
          <ion-label>
            <h2>{{ i + 1 }}. {{ t.nev }}</h2>
            <p *ngIf="t.rovid">{{ t.rovid }}</p>
          </ion-label>
          <ion-button slot="end" fill="outline" size="small" (click)="openFormaModal(t)">
            <ion-icon slot="start" name="options-outline"></ion-icon>
            Értékelési formák
          </ion-button>
        </ion-item>
      </ion-list>

      <div class="ion-padding-top" *ngIf="tantargyak.length">
        <ion-button color="primary" (click)="mentes()" [disabled]="mentesFolyamatban">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          Sorrend mentése
        </ion-button>
      </div>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</div>

<ion-modal [isOpen]="formaModalOpen" (didDismiss)="closeFormaModal()">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ formaModalTantargy?.nev }} – értékelési formák</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="closeFormaModal()">Bezár</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <p>
        Évfolyamonként választható, hogy a tantárgy záróértékelése milyen formá(k)ban
        rögzíthető. Több forma is engedélyezhető; a tanár ezek közül választ a bevitelnél.
      </p>

      <ion-note *ngIf="formaBetolt">Betöltés…</ion-note>
      <ion-note color="medium" *ngIf="!formaBetolt && !formaEvfolyamok.length">
        Nincs ehhez a tantárgyhoz rendelt évfolyam.
      </ion-note>

      <ion-list *ngIf="formaEvfolyamok.length">
        <ion-item *ngFor="let sor of formaEvfolyamok" lines="full">
          <ion-label>
            <h2>{{ sor.evfolyam }}. évfolyam</h2>
            <div class="forma-checkboxok">
              <ion-chip
                *ngFor="let f of formaOpciok"
                [color]="isFormaKivalasztva(sor, f.key) ? 'primary' : 'medium'"
                [outline]="!isFormaKivalasztva(sor, f.key)"
                (click)="toggleForma(sor, f.key, !isFormaKivalasztva(sor, f.key))"
              >
                <ion-icon [name]="isFormaKivalasztva(sor, f.key) ? 'checkmark-circle' : 'ellipse-outline'"></ion-icon>
                <ion-label>{{ f.cimke }}</ion-label>
              </ion-chip>
            </div>
          </ion-label>
        </ion-item>
      </ion-list>

      <div class="ion-padding-top" *ngIf="formaEvfolyamok.length">
        <ion-button expand="block" color="primary" (click)="mentFormak()" [disabled]="formaMent">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          Mentés
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
